exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chart-wrapper[data-v-22f877d0] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports
